import { DefaultService } from '@/services/DefaultService';

export default class StatusComercialService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(sc) {
        return this._http.post(`${this._env}/vendas/statuscomercial`, sc, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id) {
        return this._http.get(`${this._env}/vendas/statuscomercial/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/vendas/statuscomercial/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(column, order,page, limit, ...param) {
        return this._http.get(encodeURI(`${this._env}/vendas/statuscomercial.json?page=${page}&column=${column}&order=${order}&limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllCombo(...param) {
        return this._http.get(encodeURI(`${this._env}/vendas/getcombo/statuscomercial.json?param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

}